import { defineMessages } from 'react-intl';

type MessageKeys = 'headerTitle' | 'searchPlaceholder' | 'seeAllSkillsLabel';

export const messages: Record<
	MessageKeys,
	{ id: string; defaultMessage: string; description?: string }
> = defineMessages({
	headerTitle: {
		id: 'ai-mate.browse-skills.header-title',
		defaultMessage: 'Skills',
		description:
			'Heading displayed at the top of the inline skills directory panel where users can browse available skills.',
	},
	searchPlaceholder: {
		id: 'ai-mate.inline-browse.search-placeholder',
		defaultMessage: 'Search',
		description: 'Placeholder for the skills directory search field',
	},
	seeAllSkillsLabel: {
		id: 'ai-mate.skills-inline-browse.see-all-label',
		defaultMessage: 'See all',
		description:
			'Label for the button in the chat Skills panel header that opens the full skills directory modal.',
	},
});
